import { BarrioModel } from './barrio.model';
import { TipoPlazaModel } from './tipo-plaza.model';
import { TipoAparcamientoModel } from './tipo-aparcamiento.model';
import { LocalizacionModel } from './localizacion.model';
import { EstadoPlazaModel } from './estado-plaza.model';
import { SubBarrioModel } from './sub-barrio.model';

export class PlazaModel {

  id: number;
  subBarrio: SubBarrioModel;
  tipoPlaza: TipoPlazaModel;
  tipoAparcamiento: TipoAparcamientoModel;
  codigoQR: string;
  imagenAparcamiento: string;
  fechaAlta: string;
  calle: string;
  numero: number;
  numeroPlazas: number;
  textoCajetin: string;
  direccion: string;
  longitudPlaza: number;
  localizacion: LocalizacionModel;
  estadoPlaza: EstadoPlazaModel;
  idMapa: number;
  plazasDisponibles: number;

  constructor() {
    this.id = null;
    this.subBarrio = new SubBarrioModel();
    this.tipoPlaza = new TipoPlazaModel();
    this.tipoAparcamiento = new TipoAparcamientoModel();
    this.codigoQR = '';
    this.imagenAparcamiento = '';
    this.fechaAlta = '';
    this.calle = '';
    this.numero = null;
    this.numeroPlazas = null;
    this.textoCajetin = '';
    this.direccion = '';
    this.longitudPlaza = null;
    this.localizacion = new LocalizacionModel();
    this.estadoPlaza = new EstadoPlazaModel();
    this.idMapa = null;
    this.plazasDisponibles = 0;
  }
}
